import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';
import { InvestorDetails } from '../../../../shared/investor-details/investor-details.model';
import {
  ShrubFormGroup,
  TreeFormGroup,
} from '../../../environmental-protection-portal/trees-and-shrubs-felling-request/services/new-request-form/new-request-form.model';

export enum TSFWDRNewRequestAdditionalControlName {
  Owners = 'owners',
  OwnerOtherThanApplicant = 'ownerOtherThanApplicant',
  Trees = 'trees',
  Shrubs = 'shrubs',
  RemovalReason = 'removalReason',
  PlannedDate = 'plannedDate',
}

export const TSFWDRNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...TSFWDRNewRequestAdditionalControlName,
};

export interface TSFWDRNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [TSFWDRNewRequestControlName.Owners]: FormControl<InvestorDetails[]>;
  [TSFWDRNewRequestControlName.OwnerOtherThanApplicant]: FormControl<boolean>;
  [TSFWDRNewRequestControlName.Trees]: FormArray<FormGroup<TreeFormGroup>>;
  [TSFWDRNewRequestControlName.Shrubs]: FormArray<FormGroup<ShrubFormGroup>>;
  [TSFWDRNewRequestControlName.RemovalReason]: FormControl<string>;
  [TSFWDRNewRequestControlName.PlannedDate]: FormControl<NgbDate>;
}
